import { Anchor } from '@shared';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: -0.8rem auto 0;
  max-width: 600px;
  text-align: right;
  width: 100%;

  a {
    color: ${(props) => props.theme.grey.string()};
    font-size: 0.8rem;
    text-decoration: underline;
  }
`;

interface ForgotPasswordProps {
  href: string;
  text: string;
}

export function ForgotPassword({ href, text }: ForgotPasswordProps) {
  return (
    <Wrapper>
      <Anchor href={href}>{text}</Anchor>
    </Wrapper>
  );
}
